import type { Dictionary } from '../types'

export const tr: Dictionary = {
  inbox: {
    pageTitle: 'Birleşik Gelen Kutusu',
    subtitle: 'WhatsApp · Canlı Destek · İlan · Destek',
    pageSubtitle: 'WhatsApp · Canlı Destek · İlan · Destek',
    channelAll: 'Tüm kanallar',
    allChannels: 'Tüm kanallar',
    channelWhatsapp: 'WhatsApp',
    channelLivechat: 'Canlı Destek',
    channelAdvert: 'İlan',
    channelTicket: 'Destek',
    colChannel: 'Kanal',
    colPerson: 'Kişi',
    colContact: 'Kişi',
    colLastMessage: 'Son mesaj',
    noConversation: 'Konuşma bulunamadı.',
    noConversations: 'Konuşma bulunamadı.',
    selectConversation: 'Görüntülemek için bir konuşma seçin',
    messagesLoading: 'Mesajlar yükleniyor…',
    noMessages: 'Mesaj yok.',
    replyPlaceholder: 'Yanıt yazın…',
    sendBtn: 'Gönder',
    addEmoji: 'Emoji ekle',
    noReplySupport: 'Bu kanalda yanıt gönderme desteklenmiyor.',
    replyNotSupported: 'Bu kanalda yanıt gönderme desteklenmiyor.',
    pageLabel: 'Sayfa: {label}',
    currentPage: 'Sayfa',
    homePage: 'Ana Sayfa',
    replySent: 'Yanıt gönderildi',
    replyFailed: 'Yanıt gönderilemedi',
  },

  tickets: {
    pageTitle: 'Destek Masası',
    orderTicketsTitle: 'Müşteri Talepleri',
    orderTicketsBadge: 'Sipariş Bazlı',
    statusOpen: 'Açık',
    statusInProgress: 'İşlemde',
    statusClosed: 'Kapalı',
    priorityAll: 'Öncelik',
    filterPriority: 'Öncelik',
    priorityLow: 'Düşük',
    priorityMedium: 'Orta',
    priorityHigh: 'Yüksek',
    priorityUrgent: 'Acil',
    allStatuses: 'Tümü',
    filterAll: 'Tümü',
    loadingTickets: 'Yükleniyor…',
    noTickets: 'Talep bulunamadı.',
    slaExpired: 'Süre doldu',
    slaLessThanHour: '< 1 sa kaldı',
    slaLessThan1h: '< 1 sa kaldı',
    slaHours: '{h} sa kaldı',
    slaHoursLeft: '{h} sa kaldı',
    slaDays: '{d} gün kaldı',
    slaDaysLeft: '{d} gün kaldı',
    slaExceeded: 'SLA Aşıldı',
    slaBreached: 'SLA Aşıldı',
    slaLabel: 'SLA',
    selectTicket: 'Sol listeden bir talep seçin',
    priorityLowOption: 'Düşük Öncelik',
    priorityMediumOption: 'Orta Öncelik',
    priorityHighOption: 'Yüksek Öncelik',
    priorityUrgentOption: 'Acil',
    unassigned: '— Atanmamış —',
    firstResponse: 'İlk yanıt',
    orderRef: 'Sipariş',
    customer: 'Müşteri',
    noMessages: 'Henüz mesaj yok.',
    replyPlaceholder: 'Yanıt yaz…',
    sendBtn: 'Gönder',
    addEmoji: 'Emoji ekle',
    ticketClosed: 'Bu talep kapatılmış. Yanıt göndermek için durumu değiştirin.',
    closedNote: 'Bu talep kapatılmış. Yanıt göndermek için durumu değiştirin.',
    messageCount: '{n} mesaj',
    searchPlaceholder: 'Ara…',
  },

  livechat: {
    title: 'Canlı Destek',
    pageTitle: 'Canlı Destek',
    filterActive: 'Aktif',
    filterOpen: 'Açık',
    filterInProgress: 'Devam',
    filterClosed: 'Kapalı',
    filterAll: 'Tümü',
    noSessions: 'Sohbet yok.',
    assignBtn: 'Ata',
    unassignBtn: 'Atamayı kaldır',
    closeBtn: 'Kapat',
    closeResolved: 'Çözüldü',
    closeUnresolved: 'Çözülemedi',
    closeSession: 'Oturumu kapat',
    closedResolved: 'Bu sohbet çözüldü olarak kapatıldı.',
    closedUnresolved: 'Bu sohbet çözülemedi olarak kapatıldı.',
    closedByCustomer: 'Müşteri sohbeti kapattı.',
    closedTimeout: 'Uzun süre işlem olmadığı için sohbet kapatıldı.',
    pageLabel: 'Sayfa: {label}',
    currentPage: 'Sayfa',
    homePage: 'Ana Sayfa',
    sessionClosed: 'Bu sohbet kapatılmış.',
    closedNote: 'Bu sohbet kapatılmış.',
    selectSession: 'Soldaki listeden bir sohbet seçin.',
    messagePlaceholder: 'Mesaj yazın… (Enter gönderir)',
    statusOpen: 'Açık',
    statusInProgress: 'Devam Ediyor',
    statusClosed: 'Kapalı',
    addEmoji: 'Emoji ekle',
    displayNameLabel: 'Müşteriye görünen ad',
    displayNameHint: 'Gerçek kullanıcı adınız yerine bu takma ad görünür. Boş bırakılırsa “Destek” yazılır.',
    displayNamePlaceholder: 'Örn: Destek Uzmanı',
    displayNameSaved: 'Takma ad kaydedildi.',
    displayNameSave: 'Kaydet',
  },

  whatsapp: {
    title: 'WhatsApp',
    filterOpen: 'Açık',
    filterClosed: 'Kapalı',
    filterAll: 'Tümü',
    noChats: 'Sohbet yok.',
    statusOpen: 'Açık',
    statusClosed: 'Kapalı',
    statusAll: 'Tümü',
    selectChat: 'Soldaki listeden bir sohbet seçin.',
    messagePlaceholder: 'Mesaj yazın… (Enter gönderir)',
    sessionClosed: 'Bu sohbet kapatılmış.',
    chatClosed: 'Bu sohbet kapatılmış.',
    searchPlaceholder: 'Sohbet veya telefon ara…',
    emptyTitle: 'WhatsApp Web',
    backToList: 'Sohbet listesine dön',
    refresh: 'Yenile',
    send: 'Gönder',
    demoBanner: 'Örnek tasarım verisi — canlı bağlantı yok. Zorla önizleme:',
    noPreview: 'Mesaj yok',
    closeChat: 'Sohbeti kapat',
    reopenChat: 'Yeniden aç',
    chatClosedToast: 'Sohbet kapatıldı.',
    chatReopenedToast: 'Sohbet yeniden açıldı.',
    chatOpenedToast: 'Sohbet açıldı.',
    openChatFailed: 'Sohbet açılamadı.',
    groupChat: 'Grup',
    addEmoji: 'Emoji ekle',
  },
}

export const en: Dictionary = {
  inbox: {
    pageTitle: 'Unified Inbox',
    subtitle: 'WhatsApp · Live Chat · Listings · Support',
    pageSubtitle: 'WhatsApp · Live Chat · Listings · Support',
    channelAll: 'All channels',
    allChannels: 'All channels',
    channelWhatsapp: 'WhatsApp',
    channelLivechat: 'Live Chat',
    channelAdvert: 'Listings',
    channelTicket: 'Support',
    colChannel: 'Channel',
    colPerson: 'Person',
    colContact: 'Person',
    colLastMessage: 'Last message',
    noConversation: 'No conversations found.',
    noConversations: 'No conversations found.',
    selectConversation: 'Select a conversation to view',
    messagesLoading: 'Loading messages…',
    noMessages: 'No messages.',
    replyPlaceholder: 'Write a reply…',
    sendBtn: 'Send',
    addEmoji: 'Add emoji',
    noReplySupport: 'Replies are not supported on this channel.',
    replyNotSupported: 'Replies are not supported on this channel.',
    pageLabel: 'Page: {label}',
    currentPage: 'Page',
    homePage: 'Home',
    replySent: 'Reply sent',
    replyFailed: 'Failed to send reply',
  },

  tickets: {
    pageTitle: 'Help Desk',
    orderTicketsTitle: 'Customer Requests',
    orderTicketsBadge: 'Order-based',
    statusOpen: 'Open',
    statusInProgress: 'In Progress',
    statusClosed: 'Closed',
    priorityAll: 'Priority',
    filterPriority: 'Priority',
    priorityLow: 'Low',
    priorityMedium: 'Medium',
    priorityHigh: 'High',
    priorityUrgent: 'Urgent',
    allStatuses: 'All',
    filterAll: 'All',
    loadingTickets: 'Loading…',
    noTickets: 'No tickets found.',
    slaExpired: 'Expired',
    slaLessThanHour: '< 1 hr left',
    slaLessThan1h: '< 1 hr left',
    slaHours: '{h} hr left',
    slaHoursLeft: '{h} hr left',
    slaDays: '{d} days left',
    slaDaysLeft: '{d} days left',
    slaExceeded: 'SLA Breached',
    slaBreached: 'SLA Breached',
    slaLabel: 'SLA',
    selectTicket: 'Select a ticket from the list',
    priorityLowOption: 'Low Priority',
    priorityMediumOption: 'Medium Priority',
    priorityHighOption: 'High Priority',
    priorityUrgentOption: 'Urgent',
    unassigned: '— Unassigned —',
    firstResponse: 'First response',
    orderRef: 'Order',
    customer: 'Customer',
    noMessages: 'No messages yet.',
    replyPlaceholder: 'Write a reply…',
    sendBtn: 'Send',
    addEmoji: 'Add emoji',
    ticketClosed: 'This ticket is closed. Change the status to send a reply.',
    closedNote: 'This ticket is closed. Change the status to send a reply.',
    messageCount: '{n} messages',
    searchPlaceholder: 'Search…',
  },

  livechat: {
    title: 'Live Chat',
    pageTitle: 'Live Chat',
    filterActive: 'Active',
    filterOpen: 'Open',
    filterInProgress: 'In Progress',
    filterClosed: 'Closed',
    filterAll: 'All',
    noSessions: 'No chats.',
    assignBtn: 'Assign',
    unassignBtn: 'Remove assignment',
    closeBtn: 'Close',
    closeResolved: 'Resolved',
    closeUnresolved: 'Not resolved',
    closeSession: 'End session',
    closedResolved: 'This chat was closed as resolved.',
    closedUnresolved: 'This chat was closed as not resolved.',
    closedByCustomer: 'The customer closed this chat.',
    closedTimeout: 'This chat was closed after a period of inactivity.',
    pageLabel: 'Page: {label}',
    currentPage: 'Page',
    homePage: 'Home',
    sessionClosed: 'This chat is closed.',
    closedNote: 'This chat is closed.',
    selectSession: 'Select a chat from the list.',
    messagePlaceholder: 'Type a message… (Enter to send)',
    statusOpen: 'Open',
    statusInProgress: 'In Progress',
    statusClosed: 'Closed',
    addEmoji: 'Add emoji',
    displayNameLabel: 'Name shown to customers',
    displayNameHint: 'Customers see this nickname instead of your real username. Empty defaults to “Support”.',
    displayNamePlaceholder: 'e.g. Support Agent',
    displayNameSaved: 'Nickname saved.',
    displayNameSave: 'Save',
  },

  whatsapp: {
    title: 'WhatsApp',
    filterOpen: 'Open',
    filterClosed: 'Closed',
    filterAll: 'All',
    noChats: 'No chats.',
    statusOpen: 'Open',
    statusClosed: 'Closed',
    statusAll: 'All',
    selectChat: 'Select a chat from the list.',
    messagePlaceholder: 'Type a message… (Enter to send)',
    sessionClosed: 'This chat is closed.',
    chatClosed: 'This chat is closed.',
    searchPlaceholder: 'Search chat or phone…',
    emptyTitle: 'WhatsApp Web',
    backToList: 'Back to chat list',
    refresh: 'Refresh',
    send: 'Send',
    demoBanner: 'Sample design data — no live connection. Force preview:',
    noPreview: 'No messages',
    closeChat: 'Close chat',
    reopenChat: 'Reopen',
    chatClosedToast: 'Chat closed.',
    chatReopenedToast: 'Chat reopened.',
    chatOpenedToast: 'Chat opened.',
    openChatFailed: 'Could not open chat.',
    groupChat: 'Group',
    addEmoji: 'Add emoji',
  },
}
